//  toFix 图片不会自动应用cdn 前缀  https://github.com/vercel/next.js/issues/33488#issuecomment-1879127189

import NextImage, { ImageLoaderProps } from "next/image";

type NextImageProps = React.ComponentProps<typeof NextImage>;

const imageLoader = ({ src }: ImageLoaderProps) => {
  return process.env.NODE_ENV === "development"
    ? src
    : `${process.env.NEXT_PUBLIC_CDN_URL}/_next/public${src}`;
};

const Image = ({ ...props }: NextImageProps) => {
  return <NextImage loader={imageLoader} {...props} loading="lazy" />;
};

export default Image;
